module.exports = __webpack_public_path__ + "static/media/favicon.0132538c.jpg";